module.exports = {"pageTitle":"공지사항 수정","status":"상태","active":"활성화","inactive":"비활성화","type":"유형","typePlaceholder":"유형을 선택하세요.","searchPlaceholder":"검색어를 입력하세요.","version":"버전","event":"이벤트","checking":"확인중","target":"대상","targetPlaceholder":"대상을 선택하세요.","selectAll":"전체선택","alarmSent":"알림 발송 완료","titleLabel":"제목","titlePlaceholder":"제목을 입력하세요.","contentPlaceholder":"내용을 입력하세요.","golfClubCount":"골프클럽({n})","editAlertHtml":"공지를 수정하면 대상골프클럽에게<br />알림이 발송됩니다.<br />이대로 등록하시겠습니까?","requiredAlert":"필수 입력사항을<br />확인해주세요.","editedAlert":"수정되었습니다."}


//////////////////
// WEBPACK FOOTER
// ./src/locales/ko/cs004.json
// module id = nCCa
// module chunks = 2